var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcYoghurtGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aeb0b0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.44,17.79H12.56v1.3h1.38l1.8,26.81a2.62,2.62,0,0,0,.53,1.44,2.55,2.55,0,0,0,1.26.88v1.23a1.95,1.95,0,0,0,1.94,1.94H40.54a1.95,1.95,0,0,0,1.94-1.94V48.22a2.55,2.55,0,0,0,1.25-.87,2.65,2.65,0,0,0,.54-1.43l1.79-26.83h1.38Zm-6.78,19.9a.66.66,0,0,1-.19.46.64.64,0,0,1-.46.19,3.14,3.14,0,0,0-3.12,3.13.64.64,0,0,1-.19.45.66.66,0,0,1-.46.19H23.76a.65.65,0,0,1-.65-.64,3.15,3.15,0,0,0-.91-2.21A3.12,3.12,0,0,0,20,38.34a.65.65,0,0,1-.64-.65V28.47a.64.64,0,0,1,.64-.64,3.12,3.12,0,0,0,3.12-3.12.65.65,0,0,1,.65-.65H36.24a.65.65,0,0,1,.65.65A3.14,3.14,0,0,0,40,27.83a.65.65,0,0,1,.65.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,28.65c-3.51,0-6.27,1.94-6.27,4.44s2.76,4.44,6.27,4.44,6.27-1.94,6.27-4.44S33.52,28.65,30,28.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.8,11.71a3,3,0,0,0-3-3.1,3,3,0,0,0-3,3.1V16.5H22.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcYoghurtGray);
export default __webpack_public_path__ + "static/media/DC__Yoghurt_gray.26dbaedd8d62a64a35fae7f369160506.svg";
export { ForwardRef as ReactComponent };